/* eslint-disable no-param-reassign */
import { RESULT } from 'shared/api/query/constants';
import { addOrUpdateObjectInArray, addOrUpdateObjectsInArray,
  removeObjectInArray, removeObjectsInArray } from 'shared/lib/array/write';
import { getDefaultState } from '@/store/helper';
import { user as userConfig } from 'shared/api/query/configs.json';

export default {
  USER_NOT_LOGGED_IN(state) {
    state.isLoggedIn = false;
    state.loggedInUserId = 0;
    state.me = null;
    state.currentTenant = null;
    state.stepUp = null;
  },
  STEP_UP_REQUIRED(state, stepUp) {
    if (state.stepUp !== null) {
      return;
    }
    state.stepUp = stepUp;
  },
  STEP_UP_RESOLVED(state) {
    state.stepUp = null;
  },
  ME_RETRIEVED(state, me) {
    state.me = me;
    state.currentTenant = null;
  },
  TENANT_RESOLVED(state, currentTenant) {
    state.currentTenant = currentTenant;
  },
  // Replace the /me snapshot mid-session without resetting currentTenant (which ME_RETRIEVED
  // does for bootstrap/switch) — the tenant is resolved from the route, not from /me, and
  // nothing re-resolves it outside app-start.
  ME_REFRESHED(state, me) {
    state.me = me;
  },
  ENABLE_MAINTENANCE_MODE(state) {
    state.maintenanceMode = true;
  },
  LOGGED_IN_USER_RETRIEVED(state, { userId }) {
    state.isLoggedIn = true;
    state.loggedInUserId = userId;
  },
  PUBLISHED_VIEW_DATA(state) {
    state.isLoggedIn = true;
    state.loggedInUserId = Object.keys(state.nebula[`${userConfig.model}`])[0];
  },
  FIRST_LOADING(state, { routeKey, loading = false }) {
    state.firstLoading[routeKey] = loading;
  },
  RESET_STATE(state) {
    Object.assign(state, {
      ...getDefaultState(),
      appVersion: state.appVersion,
      semverVersion: state.semverVersion,
      clientInfo: state.clientInfo,
      registerURLs: state.registerURLs,
      publicAccountData: state.publicAccountData,
    });
    localStorage.clear();
  },
  SET_SWITCHING_ACCOUNT(state, value) {
    state.switchingAccount = value;
  },
  ENTITY_DELETED(state, { entity, model }) {
    removeObjectInArray(state[model], entity);
  },
  ENTITIES_DELETED(state, { entities, model }) {
    removeObjectsInArray(state[model], entities);
  },
  ENTITY_RETRIEVED(state, { entity, model }) {
    if (Array.isArray(state[model])) {
      addOrUpdateObjectInArray(state[model], entity);
      return;
    }
    state[model] = entity;
  },
  ENTITIES_RETRIEVED(state, { entities, key }) {
    state[key] = entities;
  },
  REGISTER_URLS(state, { urls }) {
    state.registerURLs = urls;
  },
  LOGIN_URLS(state, { urls }) {
    state.loginURLs = urls;
  },
  TRASH_ITEMS_RETRIEVED(state, { data, model }) {
    addOrUpdateObjectsInArray(state.trashItems[model], data[RESULT]);
  },
  TRASH_ITEM_RESTORED(state, { entity, model }) {
    removeObjectsInArray(state.trashItems[model], [{ uid: entity.uid }]);
    state.trashItems.count[model] -= 1;
  },
  TRASH_ITEMS_RESTORED(state, { entities, model }) {
    entities.forEach((entity) => {
      removeObjectsInArray(state.trashItems[model], [{ uid: entity.uid }]);
      state.trashItems.count[model] -= 1;
    });
  },
  TRASH_ITEM_REMOVE(state, { entity, model }) {
    removeObjectsInArray(state.trashItems[model], [{ uid: entity.uid }]);
  },
  TRASH_ITEMS_REMOVE(state, { entities, model }) {
    entities.forEach((entity) => {
      removeObjectsInArray(state.trashItems[model], [{ uid: entity.uid }]);
    });
  },
  TRASH_ITEMS_RESET(state, { model }) {
    state.trashItems[model] = [];
    state.trashItems.count[model] = undefined;
  },
  UPDATE_TRASH_ITEMS_COUNT(state, { model, count }) {
    state.trashItems.count[model] = count;
  },
  ENTITIES_RETRIEVED_V2(state, { entities, model }) {
    addOrUpdateObjectsInArray(state[model], entities);
  },
  APP_VERSION_RETRIEVED(state, { version, semverVersion }) {
    state.appVersion = version;
    state.semverVersion = semverVersion;
  },
  UNSET_FOREIGN_LOGIN(state) {
    state.foreignLogin = false;
  },
  ENTITIES_RETRIEVED_V3(state, { data, model, options }) {
    addOrUpdateObjectsInArray(state[model], data[options.alias]);
  },
  PAGE_VISIT_CREATED(state, { entity }) {
    state.pageVisit.unshift(entity);
    if (state.pageVisit.length > 20) {
      state.pageVisit.pop();
    }
  },
  PAGE_VISIT_NODE_ENRICHED(state, { node }) {
    state.pageVisit.forEach((current) => {
      if (typeof current.node === 'undefined'
                || typeof current.node.uid === 'undefined') {
        return;
      }
      if (current.node.uid === node.uid) {
        current.node = node;
      }
    });
  },
  PAGE_VISIT_RETRIEVED(state, { entities }) {
    state.pageVisit = entities;
  },
  PUBLIC_ACCOUNT_DATA_RETRIEVED(state, { publicAccountData }) {
    state.publicAccountData = publicAccountData;
  },
  SET_CLIENT_INFO(state, clientInfo) {
    state.clientInfo = clientInfo;
  },
  USER_PROVISIONING_STATUS(state, { provisioningStatus }) {
    state.provisioningStatus = provisioningStatus;
  },
};
/* eslint-enable no-param-reassign */
